import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Award, Clock, Star } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { API } from './stars';

const num = (v) => parseFloat(String(v).replace(',', '.'));

const Field = ({ label, suffix, value, onChange, testId, step = '0.1' }) => (
  <label className="flex items-center gap-3 text-sm text-slate-700">
    <span className="w-56">{label}</span>
    <Input type="number" step={step} value={value} onChange={e => onChange(e.target.value)} className="w-28" data-testid={testId} />
    <span className="text-slate-500">{suffix}</span>
  </label>
);

// Süper Admin: düşük puan eşiği + Altın Firma/Personel şartları
export const FiveStarSettingsCard = ({ onSaved }) => {
  const [f, setF] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { axios.get(`${API}/five-star/settings`).then(r => setF(r.data)).catch(() => {}); }, []);
  if (!f) return null;
  const save = async () => {
    setSaving(true);
    try {
      const { data } = await axios.put(`${API}/five-star/settings`, { threshold: num(f.threshold), gold_avg: num(f.gold_avg), gold_jobs: parseInt(f.gold_jobs, 10), overdue_days: parseInt(f.overdue_days, 10) });
      setF(data); onSaved?.(data); toast.success('Five Star ayarları kaydedildi');
    } catch (e) { toast.error(e.response?.data?.detail || 'Kaydedilemedi'); } finally { setSaving(false); }
  };
  return (
    <div className="max-w-3xl space-y-4" data-testid="five-star-settings">
      <Card className="border-slate-200">
        <CardHeader>
          <CardTitle className="flex items-center gap-2"><Star className="h-5 w-5 fill-amber-400 text-amber-400" />Düşük Puan Eşiği</CardTitle>
          <CardDescription>Ortalaması bu değerin altındaki firma ve personel, Çalışma İzinleri sayfasında kırmızı <b>"Düşük puan"</b> etiketiyle gösterilir; bu firmalardan gelen yeni talepler için İSG, Süper Admin ve 2. onaycıya uyarı çıkar. Denetimde art arda bu değerin altında kalan puanlarda "Tekrarlıyor" uyarısı da buna göre çalışır.</CardDescription>
        </CardHeader>
        <CardContent><Field label="Düşük puan eşiği" suffix="/ 5" value={f.threshold} onChange={v => setF({ ...f, threshold: v })} testId="five-star-threshold-input" /></CardContent>
      </Card>
      <Card className="border-yellow-300">
        <CardHeader>
          <CardTitle className="flex items-center gap-2"><Award className="h-5 w-5 text-amber-500" />Altın Firma / Altın Personel Şartları</CardTitle>
          <CardDescription>Ortalaması ve iş sayısı bu değerlere ulaşan firmalar "Altın Firma", personel "Altın Personel" rozeti alır. Firma ilk kez Altın Firma olduğunda teşekkür sertifikası otomatik gönderilir.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <Field label="En az ortalama puan" suffix="/ 5" value={f.gold_avg} onChange={v => setF({ ...f, gold_avg: v })} testId="five-star-gold-avg-input" />
          <Field label="En az iş sayısı" suffix="iş" step="1" value={f.gold_jobs} onChange={v => setF({ ...f, gold_jobs: v })} testId="five-star-gold-jobs-input" />
        </CardContent>
      </Card>
      <Card className="border-red-200">
        <CardHeader>
          <CardTitle className="flex items-center gap-2"><Clock className="h-5 w-5 text-red-600" />Denetim Bekleme Süresi</CardTitle>
          <CardDescription>Onaylı talebin çalışma başlangıç tarihinden bu kadar gün geçtiği halde hiç Five Star denetimi yapılmamışsa, talep Five Star Denetimi sayfasında ve Dashboard'da kırmızı uyarıyla gösterilir.</CardDescription>
        </CardHeader>
        <CardContent><Field label="Bekleme süresi" suffix="gün" step="1" value={f.overdue_days} onChange={v => setF({ ...f, overdue_days: v })} testId="five-star-overdue-days-input" /></CardContent>
      </Card>
      <Button onClick={save} disabled={saving} data-testid="five-star-settings-save">Kaydet</Button>
    </div>
  );
};
